// app/javascript/controllers/vendor_main_file_controller.js
import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ["fileInput", "fileList", "template"];

  connect() {
    this.loadExistingFiles();
    console.log('Connected to vendor file upload controller');
  }

  loadExistingFiles() {
    const vendorFiles = this.element.dataset.vendorFiles ? JSON.parse(this.element.dataset.vendorFiles) : [];
    vendorFiles.forEach((file) => {
      this.addExistingFile(file);
    });
  }

  addExistingFile(file) {
    const template = this.templateContent();
    template.querySelector(".file-name").textContent = file.og_file_name;
    template.querySelector('[data-file-target="viewLink"]').href = file.url;
    template.querySelector('[data-file-target="downloadLink"]').href = file.url + "?disposition=attachment";
    template.querySelector('[data-file-target="downloadLink"]').download = file.og_file_name;
    template.querySelector('.description').value = file.description || "";
    template.querySelector('[data-file-target="deleteButton"]').setAttribute('data-file-id', file.id); // Ensure file ID is set
    this.fileListTarget.appendChild(template);
  }

  triggerFileInput() {
    this.fileInputTarget.click();
  }

  generateShortUUID(length = 8) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  addFile(event) {
    const files = event.target.files;

    for (const file of files) {
      const template = this.templateContent();
      const index = `new_${this.generateShortUUID(8)}`;

      template.querySelector(".file-name").textContent = file.name;

      // Create hidden input for original file name
      const ogFileNameInput = document.createElement("input");
      ogFileNameInput.type = "hidden";
      ogFileNameInput.name = `vendor[file_records_attributes][${index}][og_file_name]`;
      ogFileNameInput.value = file.name;

      // Create hidden input for description
      const descriptionInput = template.querySelector(".description");
      descriptionInput.name = `vendor[file_records_attributes][${index}][description]`;

      // Create hidden input for category
      const categoryInput = template.querySelector(".category");
      categoryInput.name = `vendor[file_records_attributes][${index}][category]`;
      categoryInput.value = "vendor";

      // Clone the original file input
      const hiddenFileInput = document.createElement("input");
      hiddenFileInput.type = "file";
      hiddenFileInput.name = `vendor[file_records_attributes][${index}][file]`;
      hiddenFileInput.classList.add("hidden");

      // Create a new FileList containing only the current file
      const dataTransfer = new DataTransfer();
      dataTransfer.items.add(file);
      hiddenFileInput.files = dataTransfer.files;

      const fileItemContainer = template.querySelector('.file-item');
      fileItemContainer.appendChild(hiddenFileInput);
      fileItemContainer.appendChild(ogFileNameInput);
      fileItemContainer.appendChild(categoryInput);

      // Remove view and download links for new files
      template.querySelector('[data-file-target="viewLink"]').remove();
      template.querySelector('[data-file-target="downloadLink"]').remove();

      // Set file ID for deletion
      template.querySelector('[data-file-target="deleteButton"]').setAttribute('data-file-id', index);

      this.fileListTarget.appendChild(template);
    }
    this.fileInputTarget.value = "";
  }

  templateContent() {
    const template = this.templateTarget;
    return template.content.cloneNode(true);
  }

  deleteFile(event) {
    const deleteButton = event.target.closest('[data-file-target="deleteButton"]');
    const fileId = deleteButton.getAttribute("data-file-id");

    if (!fileId) {
      console.error("Missing file ID for deletion");
      return;
    }

    if (confirm('Are you sure you want to delete this file?')) {
      if (fileId.startsWith('new_')) {
        event.target.closest('.file-item').remove();
      } else {
        this.deleteFileFromBackend(fileId, event);
      }
    }

    this.fileInputTarget.value = "";
  }

  async deleteFileFromBackend(fileId, event) {
    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute("content");

    const accId = this.element.dataset.accId;
    const vendorId = this.element.dataset.vendorId;

    console.log('Deleting file:', { accId, vendorId, fileId });

    try {
      const response = await fetch(`/accounts/${accId}/vendors/${vendorId}/delete_file_record/${fileId}`, {
        method: 'DELETE',
        headers: {
          'X-CSRF-Token': csrfToken,
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        const data = await response.json();
        event.target.closest('.file-item').remove();
        console.log(data.message); // Optionally log the success message

        // Optionally refresh the view or part of the view
        // location.reload(); // Uncomment for full page refresh
        // Turbo.visit(window.location.href, { frame: "file-list-frame" }); // Uncomment for partial refresh with Turbo
      } else {
        const data = await response.json();
        alert(data.message || 'Failed to delete the file.');
      }
    } catch (error) {
      console.error('Error deleting file:', error);
      alert('An error occurred while deleting the file.');
    }
  }
}
